import Header from '../../components/Header'
import { useTheme } from '../../contexts/ThemeContext'
import 'primeicons/primeicons.css'

export default function ClassesPage() {
  const { theme } = useTheme()

  const handleZaloContact = (phone: string) => {
    window.open(`https://zalo.me/${phone}`, '_blank')
  }

  const classLocations = [
    {
      name: 'Sân Bóng Vạn Xuân - Tân Bình',
      address: '18D Cộng Hòa, Phường 4, Tân Bình, TP. Hồ Chí Minh',
      schedule: '19h00 Thứ 7 hàng tuần'
    },
    {
      name: 'Sân Bóng Cầu Xéo - Tân Phú',
      address: '15/12/2 Cầu Xéo, Tân Quý, Tân Phú, TP. Hồ Chí Minh',
      schedule: 'Thứ 5: 19h30 & Chủ nhật: 19h00'
    }
  ]

  const features = [
    {
      image: '/images/1.jpg',
      text: 'Tạo môi trường lành mạnh cho người lớn đam mê bóng đá'
    },
    {
      image: '/images/2.jpg',
      text: 'Coach Khang cùng đội ngũ trợ lý giàu kinh nghiệm'
    },
    {
      image: '/images/3.jpg',
      text: 'Từ cơ bản đến nâng cao với chương trình rõ ràng'
    }
  ]

  const galleryImages = [
    { id: 1, src: '/images/about2.jpg', alt: 'Lớp học Saigon FC 1' },
    { id: 2, src: '/images/team-photo-1-BB_Ia2hP.jpg', alt: 'Lớp học Saigon FC 2' },
    { id: 3, src: '/images/IMG_5483.jpg', alt: 'Lớp học Saigon FC 3' },
    { id: 4, src: '/images/IMG_5476.jpg', alt: 'Lớp học Saigon FC 4' },
    { id: 5, src: '/images/IMG_7530.jpg', alt: 'Lớp học Saigon FC 5' },
    { id: 6, src: '/images/team-photo-5-C0SrJ7XR.jpg', alt: 'Lớp học Saigon FC 6' }
  ]

  return (
    <main className={`min-h-screen ${theme === 'dark' ? 'bg-black' : 'bg-gray-200'}`}>
      <Header />

      {/* Header Section */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="/images/team-photo-1-BB_Ia2hP.jpg"
            alt="Classes background"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/70" />
        </div>
        <div className="relative z-10 py-16 md:py-20 px-4 text-center">
          <div className="container mx-auto max-w-4xl">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gold-400 mb-4">
              Lớp học cộng đồng
            </h1>
            <p className="text-lg md:text-xl text-gray-200 max-w-2xl mx-auto">
              Phù hợp với anh em muốn tập từ cơ bản, rèn nền tảng và chơi bóng bài bản hơn mỗi ngày
            </p>
          </div>
        </div>
      </section>

      {/* Class Locations Section */}
      <section className={`py-12 md:py-16 px-4 ${theme === 'dark' ? 'bg-black' : 'bg-white'}`}>
        <div className="container mx-auto max-w-6xl">
          <h2 className={`text-2xl md:text-3xl font-bold mb-8 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
            Địa điểm lớp học
          </h2>
          <div className="grid md:grid-cols-2 gap-6">
            {classLocations.map((location, index) => (
              <div
                key={index}
                className={`rounded-xl border-2 ${theme === 'dark' ? 'border-gold-500/40 bg-black/60' : 'border-gold-400 bg-white'} p-6 shadow-lg ${theme === 'dark' ? 'shadow-gold-500/20' : 'shadow-gray-200'}`}
              >
                <div className="flex items-center gap-3 mb-4">
                  <i className="pi pi-map-marker text-gold-400 text-2xl"></i>
                  <h3 className={`text-xl font-bold ${theme === 'dark' ? 'text-gold-400' : 'text-gold-500'}`}>
                    {location.name}
                  </h3>
                </div>
                <div className="space-y-3">
                  <div className="flex items-start gap-3">
                    <i className="pi pi-map-marker text-gold-400 text-lg mt-1"></i>
                    <p className={`text-sm md:text-base ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
                      {location.address}
                    </p>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="pi pi-clock text-gold-400 text-lg"></i>
                    <p className={`text-sm md:text-base font-semibold ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
                      {location.schedule}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className={`py-12 md:py-16 px-4 ${theme === 'dark' ? 'bg-black' : 'bg-white'}`}>
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-10 md:mb-12">
            <h2 className={`text-2xl md:text-3xl lg:text-4xl font-bold mb-3 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
              Lớp bóng đá cơ bản SaiGon FC có gì?
            </h2>
            <p className={`text-base md:text-lg ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
              Những giá trị cốt lõi mà chúng tôi mang lại
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-6 md:gap-8">
            {features.map((feature, index) => (
              <div
                key={index}
                className={`rounded-2xl border-2 overflow-hidden ${theme === 'dark'
                    ? 'border-gold-500/40 bg-black/60'
                    : 'border-gold-400/40 bg-white'
                  } shadow-lg`}
              >
                {/* Image Section */}
                <div className="relative h-48 md:h-56 overflow-hidden bg-gray-100">
                  <img
                    src={feature.image}
                    alt={feature.text}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>

                {/* Content Section */}
                <div className="p-5 md:p-6">
                  <p className={`text-sm md:text-base lg:text-lg leading-relaxed text-center font-medium ${theme === 'dark' ? 'text-gray-200' : 'text-gray-800'
                    }`}>
                    {feature.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className={`py-12 md:py-16 px-4 ${theme === 'dark' ? 'bg-black' : 'bg-white'}`}>
        <div className="container mx-auto max-w-6xl">
          <h2 className={`text-2xl md:text-3xl font-bold mb-8 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
            Hình ảnh lớp học Saigon FC
          </h2>
          <div className="grid md:grid-cols-3 gap-4">
            {galleryImages.map((image) => (
              <div
                key={image.id}
                className={`relative aspect-square rounded-xl overflow-hidden border-2 ${theme === 'dark' ? 'border-gold-500/40' : 'border-gold-400'} shadow-lg ${theme === 'dark' ? 'shadow-gold-500/20' : 'shadow-gray-200'}`}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Free Trial Section */}
      <section className={`py-12 md:py-16 px-4 ${theme === 'dark' ? 'bg-black' : 'bg-white'}`}>
        <div className="container mx-auto max-w-4xl text-center">
          <button
            onClick={() => handleZaloContact('0703577789')}
            className="px-8 py-4 bg-gold-gradient text-black font-bold text-lg md:text-xl rounded-lg mb-4"
          >
            Đăng ký tập thử miễn phí
          </button>
          <p className={`text-base md:text-lg ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
            Liên hệ Zalo: <span className="font-semibold">0703 577 789</span> (coach Nhật)
          </p>
        </div>
      </section>

      {/* Other Services Section */}
      <section
        className={`py-12 md:py-16 px-4 ${theme === 'dark' ? 'bg-black' : 'bg-gray-200'
          }`}
      >
        <div className="container mx-auto max-w-6xl">
          <h2
            className={`text-3xl md:text-4xl font-bold mb-10 text-center ${theme === 'dark' ? 'text-white' : 'text-gray-900'
              }`}
          >
            Các dịch vụ khác
          </h2>

          <div className="grid md:grid-cols-2 gap-6 items-stretch">
            {/* Corporate Training */}
            <div
              className={`rounded-xl border-2
        ${theme === 'dark'
                  ? 'border-gold-500/40 bg-black/60'
                  : 'border-gold-400 bg-white'
                }
        p-6 md:p-8 shadow-lg
        ${theme === 'dark'
                  ? 'shadow-gold-500/20'
                  : 'shadow-gray-200'
                }
        flex flex-col h-full`}
            >
              <h3
                className={`text-xl md:text-2xl font-bold mb-4 ${theme === 'dark' ? 'text-white' : 'text-gray-900'
                  }`}
              >
                Huấn luyện Doanh nghiệp
              </h3>

              <p
                className={`text-sm md:text-base leading-relaxed mb-6 ${theme === 'dark' ? 'text-gray-300' : 'text-gray-600'
                  }`}
              >
                Chương trình huấn luyện bóng đá dành riêng cho công ty, trường học,
                đội nhóm. Xây dựng tinh thần đồng đội và sức khỏe cho tập thể.
              </p>

              <button
                onClick={() => handleZaloContact('0703577789')}
                className="mt-auto w-full px-6 py-3 bg-gold-gradient text-black font-bold rounded-lg"
              >
                Liên hệ tư vấn
              </button>
            </div>

            {/* 1-on-1 Training */}
            <div
              className={`rounded-xl border-2
        ${theme === 'dark'
                  ? 'border-gold-500/40 bg-black/60'
                  : 'border-gold-400 bg-white'
                }
        p-6 md:p-8 shadow-lg
        ${theme === 'dark'
                  ? 'shadow-gold-500/20'
                  : 'shadow-gray-200'
                }
        flex flex-col h-full`}
            >
              <h3
                className={`text-xl md:text-2xl font-bold mb-4 ${theme === 'dark' ? 'text-white' : 'text-gray-900'
                  }`}
              >
                Huấn luyện 1 kèm 1
              </h3>

              <p
                className={`text-sm md:text-base leading-relaxed mb-6 ${theme === 'dark' ? 'text-gray-300' : 'text-gray-600'
                  }`}
              >
                Chương trình cá nhân hóa 100%, tập trung phát triển kỹ năng theo nhu cầu
                riêng của bạn. Thời gian và địa điểm linh hoạt.
              </p>

              <button
                onClick={() => handleZaloContact('0976950338')}
                className="mt-auto w-full px-6 py-3 bg-gold-gradient text-black font-bold rounded-lg"
              >
                Liên hệ tư vấn
              </button>
            </div>
          </div>
        </div>
      </section>

    </main>
  )
}
